<template>
  <div class="maintenance">
    <div class="maintenance__card">
      <div class="maintenance__logo"></div>
      <div class="maintenance__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
        </svg>
      </div>
      <h1 class="maintenance__title">{{ $t('maintenance.title') }}</h1>
      <p class="maintenance__message">{{ $t('maintenance.message') }}</p>
      <div class="maintenance__divider"></div>
      <p class="maintenance__submessage">{{ $t('maintenance.submessage') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceScreen',
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.maintenance {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 100px);
  background-color: var(--grey-four);
  padding: 20px;

  &__card {
    background: var(--white);
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 60px 50px;
    text-align: center;
    max-width: 520px;
    width: 100%;

    @media screen and (max-width: 520px) {
      padding: 40px 25px;
    }
  }

  &__logo {
    background: url('~assets/ep-logo.svg') no-repeat center;
    background-size: contain;
    width: 180px;
    height: 60px;
    margin: 0 auto 40px;
  }

  &__icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 24px;
    color: var(--brand-orange);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 600;
    color: var(--grey-one);
    margin: 0 0 16px;
  }

  &__message {
    font-size: 15px;
    color: #6c757d;
    line-height: 1.6;
    margin: 0 0 24px;
  }

  &__divider {
    width: 60px;
    height: 3px;
    background-color: var(--brand-orange);
    margin: 0 auto 24px;
    border-radius: 2px;
  }

  &__submessage {
    font-size: 13px;
    color: var(--grey-eight);
    margin: 0;
  }
}
</style>

<style lang="scss">
.europark-pl,
.europark-fi {
  .maintenance__logo {
    background-image: url('~assets/ep-logo-new.svg');
  }
}

.spinn {
  .maintenance__logo {
    background-image: url('~assets/spinn-logo.svg');
    width: 200px;
    height: 50px;
  }
}

.hepsor {
  .maintenance__logo {
    background-image: url('~assets/hepsor-logo.svg');
    width: 200px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MaintenanceScreen.vue